module.exports = {
  name: 'checkbox', base: '_option', prototype: {
    element_selector: 'input[type=checkbox]'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/checkbox.js
 ** module id = 10
 ** module chunks = 0
 **/